import React from "react";
import { useEffect } from "react";
import Ganti from "../../components/GantiKeperluan/Ganti";

const Index = () => {
  useEffect(() => {
    document.title = "Ganti Keperluan";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="p-6">
      <Ganti/>
    </div>
  );
};

export default Index;
